import { Component, Inject, OnInit, ViewEncapsulation } from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";

@Component({
  selector: "app-price-breakup-details",
  templateUrl: "./price-breakup-details.component.html",
  styleUrls: [
    "./price-breakup-details.component.scss",
    "../../../../../scss/responsive-modals.scss"
  ],
  encapsulation: ViewEncapsulation.None
})
export class PriceBreakupDetailsComponent implements OnInit {
  priceBreakDown: any;
  priceArray = [];

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}

  ngOnInit(): void {
    this.priceBreakDown = this.data?.details?.price?.breakdown;
    if (this.priceBreakDown) this.sortGstPercent(this.priceBreakDown);
  }

  sortGstPercent(priceBreakdown: any): void {
    for (const [key, value] of Object.entries(priceBreakdown)) {
      if (key === "gstPercent" || key === "totalCharge" || key === "gstCharge")
        this.priceArray.unshift({ key, value });
      else {
        this.priceArray.push({ key, value });
      }
    }
    if (
      this.priceArray[0].key === "gstPercent" ||
      this.priceArray[0].key === "gstCharge"
    ) {
      let gstPercent = this.priceArray[0];
      this.priceArray[0] = this.priceArray[1];
      this.priceArray[1] = gstPercent;
    }
    if (this.priceArray[1].key === "reverse_final_with_gst") {
      let reverseTotalCharge = this.priceArray[1];
      this.priceArray[1] = this.priceArray[2];
      this.priceArray[2] = this.priceArray[0];
      this.priceArray[0] = reverseTotalCharge;
    }
    this.priceArray = this.priceArray.reverse();
  }
}
